import React from 'react';

import { ComponentStageType } from '../../types';

import { ButtonBar } from '../ButtonBar';
import { Button } from '../Button';
import { ButtonRow } from '../ButtonRow';

import { createEnterExitAnimation } from '../../transitions';
import { animationDelay } from '../../constants';

interface IProps {
    stage: ComponentStageType;
    onAnimationExit(): void;
    getButtonColor(choice: boolean): string;
    onNoClick(): void;
    onYesClick(): void;
}

export const Controls: React.FC<IProps> = ({
    stage,
    onAnimationExit,
    getButtonColor,
    onNoClick,
    onYesClick,
}) => {
    const leftButtonAnimation = createEnterExitAnimation({
        stage,
        delay: animationDelay.second,
    });

    const rightButtonAnimation = createEnterExitAnimation({
        stage,
        onRest: onAnimationExit,
        delay: animationDelay.third,
    });

    return (
        <ButtonBar>
            <ButtonRow>
                <Button
                    onClick={onNoClick}
                    buttonColor={getButtonColor(false)}
                    style={{ ...leftButtonAnimation }}
                >
                    nee
                </Button>

                <Button
                    onClick={onYesClick}
                    buttonColor={getButtonColor(true)}
                    style={{ ...rightButtonAnimation }}
                >
                    ja
                </Button>
            </ButtonRow>
        </ButtonBar>
    );
};
